import * as React from 'react';
import { diContainer } from 'src/dependencyInjection/diContainer';
import { DI_TYPES } from 'src/dependencyInjection/diTypes';
import Turnstile from 'react-turnstile';
import { IEnvironmentService } from 'src/services/EnvironmentService/IEnvironmentService';

export interface ICloudFlareTurnstileComponentProps {
  onVerify: (token: string) => void;
}

export const CloudFlareTurnstileComponent: React.FunctionComponent<
  ICloudFlareTurnstileComponentProps
> = props => {
  return (
    <Turnstile
      sitekey={
        diContainer.get<IEnvironmentService>(DI_TYPES.EnvironmentService).get()
          .cloudflare.siteKey
      }
      theme='light'
      refreshExpired={'auto'}
      fixedSize={true}
      onVerify={token => {
        props.onVerify(token);
      }}
    />
  );
};
